"use strict";
exports.__esModule = true;
var design_language_1 = require("@doordash/design-language");
var react_1 = require("react");
var types_1 = require("../types");
var INPUT_SUCCESS_COLOR = design_language_1.Colors.TextSecondary;
var INPUT_ERROR_COLOR = design_language_1.Colors.TextError;
var styles = {
    'font-family': 
    // tslint:disable-next-line:max-line-length
    'DD-TTNorms, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    color: INPUT_SUCCESS_COLOR,
    'font-size': '16px',
    '-webkit-font-smoothing': 'antialiased',
    '-moz-osx-font-smoothing': 'grayscale'
};
var useGenerateVgsFormEffect = function (props) {
    var cardNumberPlaceHolder = props.cardNumberPlaceHolder, formIds = props.formIds, isVgsLoaded = props.isVgsLoaded, setForm = props.setForm, setCardData = props.setCardData, vgsConfig = props.vgsConfig;
    react_1.useEffect(function () {
        if (!isVgsLoaded) {
            return;
        }
        var vgsForm = window.VGSCollect.create(vgsConfig.VAULT_ID, vgsConfig.VAULT_ENV, function () { return setCardData({}); });
        setForm(vgsForm);
        // Configuration:
        // https://github.com/doordash/tf_cdn_cloudflare/pull/704/files
        // tslint:disable-next-line:react-hooks-nesting
        vgsForm.useCname(vgsConfig.VAULT_CNAME);
        if (formIds.cardExpiration) {
            // NOTE: expiration date should be first field for serializers to
            // merge form details correctly.
            vgsForm.field("#" + formIds.cardExpiration, {
                type: 'card-expiration-date',
                name: types_1.VgsFormFieldName.Expiration,
                successColor: INPUT_SUCCESS_COLOR,
                errorColor: INPUT_ERROR_COLOR,
                placeholder: 'MM / YY',
                validations: ['required', 'validCardExpirationDate'],
                css: styles,
                autoComplete: 'cc-exp',
                yearLength: '2',
                serializers: [
                    {
                        name: 'separate',
                        options: { monthName: 'expMonth', yearName: 'expYear' }
                    },
                ]
            });
        }
        if (formIds.cardNumber) {
            var cardNumber = vgsForm.field("#" + formIds.cardNumber, {
                type: 'card-number',
                name: types_1.VgsFormFieldName.Number,
                successColor: INPUT_SUCCESS_COLOR,
                errorColor: INPUT_ERROR_COLOR,
                placeholder: cardNumberPlaceHolder,
                showCardIcon: false,
                validations: ['required', 'validCardNumber'],
                autoComplete: 'cc-number',
                css: styles
            });
            if (formIds.cardCVC) {
                var cvc = vgsForm.field("#" + formIds.cardCVC, {
                    type: 'card-security-code',
                    name: types_1.VgsFormFieldName.CVC,
                    successColor: INPUT_SUCCESS_COLOR,
                    errorColor: INPUT_ERROR_COLOR,
                    placeholder: 'CVC',
                    validations: ['required', 'validCardSecurityCode'],
                    autoComplete: 'cc-csc',
                    css: styles
                });
                cardNumber.setCVCDependency(cvc);
            }
        }
    }, [isVgsLoaded]);
};
exports["default"] = useGenerateVgsFormEffect;
